export const adobeAnalyticsConst = {
  platform: "Website",
  language: "En",
  loginStatus: "Logged in",
  userType: "New",
};
